<template>
  <span>
    <label class="page-label">Embed</label>
    <p style="font-weight: 400px; font-size: 14px; line-height: 21px;"> {{ $t('message.pages.video.embedYourVideo') }}</p>

    <!-- <span class="mb-3"> URL: {{ livePlayer}} <br> <br> </span>
    <span> Plataforma seleciona {{ embedSelected }}  <br>  </span>
    <span>  {{ radioActive  }} </span> -->

    <label class="page-label">{{ $t('message.pages.drm.settingsForm.platform') }}</label>

    <v-select v-model="embedSelected" :items="embedOptions" item-text="text" item-value="value" dense
      prepend-inner-icon="mdi-xml" hide-details outlined no-data-text="" class="mb-3" :menu-props="{ offsetY: true }"
      @change="handleEmbedSelection" />

    <label class="page-label">Code</label>
    <v-col class="py-0 pr-0 pl-0 pt-0 pb-0">
      <v-col v-if="embedSelected === 'elementor'">
        <span class="d-flex align-center justify-center">
          <h5 align="center" style="font-size: 16px; color: #484848">
            {{ $t('message.embedModal.embedElementorText') }}
          </h5>
        </span>
        <v-col class="d-flex justify-space-around">

          <v-btn color="primary" class="white--text" :href="elementorArticle" target="_blank" small
            @click="$emit('showEmbed', false)">
            {{ $t('message.embedModal.goToPlugin') }}
          </v-btn>
        </v-col>
      </v-col>
      <v-textarea v-model="textareaContent" outlined class="wrapText embedInput" hide-details dense color="primary"
        readonly style="font-size: 14px;" @focus="$event.target.select()">
        <template v-slot:append>
          <v-tooltip bottom>

          </v-tooltip>
        </template>
      </v-textarea>
    </v-col>



    <div class="d-grid mt-5">
      <!-- <v-switch class="preload-switch  ma-0" hide-details v-model="preloadEmbed" />
      <span>
        {{ $t('message.pages.videoEditModal.embedConfiguration.preloadEmbed') }}

        <v-btn icon color="primary" :href="$t('message.embedModal.preloadEmbedHelpDesk')" target="_blank">
          <v-icon small>mdi-help-circle</v-icon>
        </v-btn>
      </span> -->


      <v-switch class="fixo pa-0 ma-0" hide-details v-model="switchValue" @change="handleSwitchChange" />
      <span>
        <span>
          {{ $t('message.pages.videoEditModal.embedConfiguration.fixed') }}
        </span>

        <div class="d-flex align-end mt-1">
          <span>
            <span v-if="switchValue" class="page-label">
              {{ $t('message.pages.videoEditModal.embedConfiguration.width') }}
            </span>
            <v-text-field v-if="switchValue" v-model="embedVideo.width" type="number" color="primary" placeholder="720px"
              outlined dense hide-details />
          </span>
          <span v-if="switchValue" class="mx-3 mb-2">X</span>
          <span>
            <span v-if="switchValue" class="page-label">
              {{ $t('message.pages.videoEditModal.embedConfiguration.height') }}
            </span>
            <v-text-field v-if="switchValue" v-model="embedVideo.height" type="number" color="primary" placeholder="360px"
              outlined dense hide-details />
          </span>
        </div>
      </span>
    </div>

      <!-- <v-switch class="ma-0" hide-details v-model="switchValueFullscreen" />
      <span>
        <span>{{
          $t('message.embedModal.playOpensFullscreenTitle3')
        }}
          <v-btn icon color="primary" :href="$t('message.embedModal.playOpensFullscreenHelpdesk')" target="_blank">
            <v-icon small>mdi-help-circle</v-icon>
          </v-btn>
        </span>
      </span>
    </div>
    <v-select v-if="switchValueFullscreen" v-model="switchValueFullscreen" :items="fullscreenOptions" item-text="text"
      item-value="value" dense hide-details outlined no-data-text="" class="mb-3" :menu-props="{ offsetY: true }"
      @change="handleEmbedSelection" /> -->
  </span>
</template>

<script>
import { embedOptions } from '@/utils/embedOptions.js'
import embedSelection from '@/utils/embedSelection.mixin.js'
import i18n from '@/translations/lang'
// eslint-disable-next-line no-unused-vars
import { aspectRatio } from '@/utils/embedSelection.mixin.js'

import embedCode from '@/utils/embedCode.mixin.js'
import embedOptionOrientations from '@/utils/embedOptionOrientations.js'
// import i18n from '@/translations/lang'

import { mapMutations } from 'vuex'

export default {
  name: 'LiveEmbed',
  mixins: [embedSelection, embedCode],
  props: {
    additionalTextAreaContent: {
      default: '',
      type: String,
    },
    video: {
      type: Object,
    },
    propsData: {
      type: Object,
      required: true,
    },
    fetching: {
      default: true,
    },
  },

  data: () => ({
    radioActive: 1,
    switchValueFullscreen: true,
    switchValue: false,
    embedSelected: 'general',
    preloadEmbed: true,
    embedView: false,
    fullscreenOptions: [
      { text: i18n.t('message.embedModal.playOpensFullscreenNative'), value: i18n.t('message.embedModal.playOpensFullscreenNative'), default: true },
      { text: i18n.t('message.embedModal.playOpensFullscreenNativeOnPlay'), value: i18n.t('message.embedModal.playOpensFullscreenNativeOnPlay') },
      { text: i18n.t('message.embedModal.playOpensFullscreen'), value: i18n.t('message.embedModal.playOpensFullscreen') }
    ],
    embedOptionOrientations,
    isLive: true,
    isCopied: false,
    embedVideo: {
      width: 720,
      height: 360,
      startTimeCheckbox: false,
      startTime: '',
    },

  }),
  computed: {
    aspectRatio() {
      const { width, height } = this.livePlayer
      let ratio = height / width

      if (Number.isNaN(ratio)) {
        ratio = 9 / 16
      }

      return `${ratio * 100}%`
    },
    embed: {
      get() {
        return this.getEmbedCode()
      },
      cache: false,
    },
    embedOptions() {
      const [general] = embedOptions.filter(
        ({ value }) => value === 'general'
      )

      let rest = []
      if (this.onlyPageOptions === true) {
        rest = embedOptions.filter(
          ({ value }) => value !== 'general' && value === 'elementor'
        )
      } else {
        rest = embedOptions.filter(({ value }) => value !== 'general')
      }

      const sorted = rest.sort((a, b) => a.value.localeCompare(b.value))


      return [general, ...sorted]
    },
    livePlayer: {
      get() { return this.propsData['livePlayer'] },
      set(value) { this.propsData['livePlayer'] = value }
    },
    liveInfo: {
      get() { return this.propsData['liveInfo'] },
      set(value) { this.propsData['liveInfo'] = value }
    },
    elementorArticle() {
      if (this.locale === 'en') {
        return 'https://help.pandavideo.com/en-us/article/how-to-install-panda-video-plugin-in-elementor-1ac6k71/'
      }
      return 'https://help.pandavideo.com/pt-br/article/como-instalar-o-plugin-da-panda-video-no-elementor-kxiv0o/'
    },
    textareaContent() {
      const isLive = this.$route.name === 'NewLive'

      const src = this.livePlayer + '&isLive=true'
      const externalId = this.livePlayer
      const code = isLive
      this.video?.live_id || this.liveInfo.id

      const hls =
        this.liveInfo.live_hls

      //EMBED PARTS

      //params
      let paramSrc = src

      let paramStartTime =
        this.embedVideo.startTimeCheckbox && this.embedVideo.startTime
          ? `&startTime=${this.embedVideo.startTime}`
          : ''
      let paramPlayOpensFullscreen = '&iosFakeFullscreen=true'
      if (this.switchValueFullscreen === false) {

        paramPlayOpensFullscreen = '&iosFakeFullscreen=true'
      } else {

        const selectedFullscreenOption = this.fullscreenOptions.find(option => option.value === this.switchValueFullscreen)

        if (selectedFullscreenOption && selectedFullscreenOption.value === i18n.t('message.embedModal.playOpensFullscreenNative')) {

          paramPlayOpensFullscreen = ''
        }
        else if (selectedFullscreenOption && selectedFullscreenOption.value === i18n.t('message.embedModal.playOpensFullscreenNativeOnPlay')) {

          paramPlayOpensFullscreen = '&playOpensFullscreenNative=true'
        }
        else if (selectedFullscreenOption && selectedFullscreenOption.value === i18n.t('message.embedModal.playOpensFullscreen')) {

          paramPlayOpensFullscreen = '&playOpensFullscreen=true'
        }
        else {

          paramPlayOpensFullscreen = '&iosFakeFullscreen=true'
        }
      }
      let paramPreload = this.preloadEmbed ? '' : '&preload=false'

      //embed parts
      let embedStart = ''
      let embedStyles = 'style="border:none;"'
      if (this.radioActive === 1) {
        embedStart = `<div style="position:relative;padding-top:${this.aspectRatio};">`
        embedStyles = embedStyles.slice(0, -1)
        embedStyles += 'position:absolute;top:0;left:0;"'
      }
      let embedEnd = this.radioActive === 1 ? '</div>' : ''
      let embedFeatures =
        'allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture" allowfullscreen=true'

      // iframe parts
      const iframeID = `panda-${(this.liveInfo ?? {}).id
        }`
      let iframeWidth = this.radioActive === 0 ? this.embedVideo.width : '100%'
      let iframeHeight =
        this.radioActive === 0 ? this.embedVideo.height : '100%'


      let embedToBeReturned = `${embedStart}<iframe id="${iframeID}" src="${paramSrc}${paramStartTime}${paramPlayOpensFullscreen}${paramPreload}" ${embedStyles} ${embedFeatures} width="${iframeWidth}" height="${iframeHeight}" fetchpriority="high"></iframe>${embedEnd}`



      if (this.embedSelected === 'entrega-digital' || this.embedSelected === 'creators-land') return this.liveInfo.id
      if (this.hlsEmbed) return hls
      if (this.codeEmbed) return code
      if (this.srcEmbed) return src
      if (this.isExternalIdEmbed) return externalId


      return embedToBeReturned
    },
  },
  watch: {
    showMenuEmbed(val) {
      this.$emit('showEmbed', val)
    },
  },
  created() {
    if (!this.fullscreenOptions.some(option => option.value === this.switchValueFullscreen)) {
      this.switchValueFullscreen = this.fullscreenOptions.find(option => option.default)?.value || null
    }
  },
  methods: {
    handleSwitchChange() {
      this.radioActive = this.switchValue ? 0 : 1
      if (this.radioActive === 1) {
        this.switchValue = false
      } else {
        this.switchValue = true
      }
    },

    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    handleShowLink(value) {
      const i18n = this.$i18next
      let text = 'Error trying coping this. Please coping directly from field'

      if (navigator && navigator.clipboard) {
        text = i18n.t('message.copiedToClipboard')
        navigator.clipboard.writeText(`${value}`)
      }

      this.UPDATE_GLOBAL_SNACKBAR({ open: true, text })
    },
  }
}
</script>


<style lang="scss" scoped>
.new-live-cover {
  display: flex;
  height: 190px;
  border-radius: 4px;
  background: var(--v-neutral-lighten3);

  align-items: center;
  justify-content: center;

  &::v-deep {
    .v-icon {
      color: var(--v-brand-base);
    }
  }
}

.embedInput {
  padding: 0 0 0 0 !important;
}

.wrapText {
  word-break: break-word;
}


.d-grid {
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: $spacing-minus-2;
  row-gap: $spacing-plus-1;
}

::v-deep {
  @import '@/assets/scss/src/new-live';

  .v-text-field fieldset,
  .v-text-field .v-input__control {
    border-color: var(--v-neutral-lighten2);
    color: var(--v-neutral-base);
  }
}

.bg-dark {
  .new-live-embed {
    background-color: var(--v-neutral-darken2);
    color: white;
  }

  .page-label {
    color: var(--v-primary-base) !important
  }
}
</style>
